import { createElement as e, useEffect, useMemo, useRef, useState } from 'react';
import { getPosts, getSchedulesRange, getEmployees } from '../data/store';
import { useAuth } from '../hooks/useAuth';

function hoyPR() {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Puerto_Rico',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).formatToParts(new Date());
  const map = {};
  parts.forEach((p) => (map[p.type] = p.value));
  return map.day + '/' + map.month + '/' + map.year;
}

function extraerHoraInicio(hours) {
  if (!hours) return null;
  const m = String(hours).match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  const ampm = m[3] ? m[3].toUpperCase() : null;
  if (ampm === 'PM' && h < 12) h += 12;
  if (ampm === 'AM' && h === 12) h = 0;
  return { h, min };
}

function formatShift12h(shift) {
  if (!shift) return '';
  if (shift.includes('AM') || shift.includes('PM')) return shift.replace('/', ' - ');
  let start = '', end = '';
  if (shift.includes('/')) { [start, end] = shift.split('/'); }
  else if (shift.includes('-')) { [start, end] = shift.split('-'); }
  else return shift;
  const convert = (time) => {
    if (!time) return '';
    let [h, m] = time.split(':');
    h = parseInt(h, 10);
    m = m ? String(m).padStart(2, '0') : '00';
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return h + ':' + m + ' ' + ampm;
  };
  return convert(start) + ' - ' + convert(end);
}

function horaPR12(hora) {
  if (!hora) return '';
  return new Date(hora).toLocaleTimeString('en-US', { timeZone: 'America/Puerto_Rico', hour: 'numeric', minute: '2-digit' });
}

function fechaPR12(hora) {
  if (!hora) return '';
  return new Date(hora).toLocaleDateString('en-GB', { timeZone: 'America/Puerto_Rico', day: '2-digit', month: '2-digit', year: 'numeric' });
}

function fechaInicioPR(fecha, h, min) {
  if (!fecha) return null;
  const partsF = fecha.split('/');
  const d2 = parseInt(partsF[0], 10);
  const mo2 = parseInt(partsF[1], 10);
  const y2 = parseInt(partsF[2], 10);
  return new Date(Date.UTC(y2, mo2 - 1, d2, h + 4, min, 0));
}

function hoyInicioPR(h, min) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Puerto_Rico',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).formatToParts(new Date());
  const map = {};
  parts.forEach((p) => (map[p.type] = p.value));
  const y = parseInt(map.year, 10);
  const mo = parseInt(map.month, 10);
  const d = parseInt(map.day, 10);
  return new Date(Date.UTC(y, mo - 1, d, h + 4, min, 0));
}

function toDatetimeLocalPR(iso) {
  if (!iso) return '';
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Puerto_Rico',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(new Date(iso));
  const map = {};
  parts.forEach((p) => { map[p.type] = p.value; });
  const hour = map.hour === '24' ? '00' : map.hour;
  return map.year + '-' + map.month + '-' + map.day + 'T' + hour + ':' + map.minute;
}

function fromDatetimeLocalPR(str) {
  if (!str) return null;
  return new Date(str + ':00-04:00').toISOString();
}

function tipoLabel(tipo) {
  if (tipo === 'in') return 'Entrada';
  if (tipo === 'meal_out') return 'Entrada Alimento';
  if (tipo === 'meal_in') return 'Salida Alimento';
  return 'Salida';
}

function tipoColor(tipo) {
  if (tipo === 'in') return '#34d399';
  if (tipo === 'out') return '#f87171';
  return '#fbbf24';
}

const TIPOS_OPCIONES = [
  { value: 'in', label: 'Entrada' },
  { value: 'out', label: 'Salida' },
  { value: 'meal_out', label: 'Entrada Alimento' },
  { value: 'meal_in', label: 'Salida Alimento' },
];

const SIN_PUESTO = '__sin_puesto__';

const cardStyle = (bg) => ({ background: bg, color: '#fff', padding: 16, borderRadius: 12, minWidth: 190 });
const cardLabel = { fontSize: 13, opacity: 0.7 };
const cardNum = { fontSize: 32, fontWeight: 700 };
const h2Style = (color) => ({ fontSize: 18, fontWeight: 600, marginBottom: 8, color: color || '#fff' });
const tdStyle = { padding: 8, color: '#ddd' };
const thStyle = { padding: 8, color: '#F5C518', textAlign: 'left', position: 'sticky', top: 0, background: '#141b26' };
const modalOverlayStyle = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 };
const modalBoxStyle = { background: '#1a2332', padding: 24, borderRadius: 12, minWidth: 320, maxWidth: '92vw', color: '#fff' };
const modalInputStyle = { padding: 8, borderRadius: 6, border: '1px solid #555', background: '#0d0d0d', color: '#fff', marginBottom: 12, width: '100%', boxSizing: 'border-box' };
const modalLabelStyle = { display: 'block', fontSize: 12, color: '#F5C518', marginBottom: 4 };
const btnGris = { background: '#333', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 14px', cursor: 'pointer' };
const btnSmall = { background: '#333', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 10px', cursor: 'pointer', fontSize: 12 };

export default function DashboardAsistencia() {
  const { can } = useAuth();
  const [ponches, setPonches] = useState([]);
  const [posts, setPosts] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [fotoModal, setFotoModal] = useState(null);
  const [leafletReady, setLeafletReady] = useState(false);
  const mapRef = useRef(null);
  const mapObjRef = useRef(null);
  const [pinIds, setPinIds] = useState([]);
  const [devices, setDevices] = useState([]);
  const [limpieza, setLimpieza] = useState(null);
  const [limpiando, setLimpiando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [guardandoEdicion, setGuardandoEdicion] = useState(false);
  const [nuevoPonche, setNuevoPonche] = useState(null);
  const [guardandoNuevo, setGuardandoNuevo] = useState(false);
  const [filtroPuesto, setFiltroPuesto] = useState('all');
  const [colapsados, setColapsados] = useState({});
  const [cargandoFotos, setCargandoFotos] = useState(null);
  const [actualizando, setActualizando] = useState(false);
  // Cache en memoria de enlaces firmados de fotos: { [ponche_id]: { frontal, trasera, nombre, expira } }
  const fotosCacheRef = useRef({});

  // ---------- Helpers de puestos / turnos ----------
  const postsPorId = useMemo(function () {
    const map = {};
    posts.forEach((p) => { map[String(p.id)] = p; });
    return map;
  }, [posts]);

  const postsOrdenados = useMemo(function () {
    return posts.slice().sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'es'));
  }, [posts]);

  function buscarTurno(employeeId, fechaDDMMYYYY, postId) {
    const delDia = schedules.filter(function (s) {
      return String(s.employeeId) === String(employeeId) && s.date === fechaDDMMYYYY && !s.isVacancy;
    });
    if (postId) {
      const exacto = delDia.find((s) => String(s.postId) === String(postId));
      if (exacto) return exacto;
    }
    return delDia[0] || null;
  }

  function sugerirPuesto(employeeId, horaLocal) {
    if (!employeeId || !horaLocal) return '';
    const fecha = fechaPR12(fromDatetimeLocalPR(horaLocal));
    const sched = buscarTurno(employeeId, fecha, null);
    return sched && sched.postId != null ? String(sched.postId) : '';
  }

  function postIdOriginal(postIdStr) {
    if (!postIdStr) return null;
    const post = postsPorId[String(postIdStr)];
    return post ? post.id : postIdStr;
  }

  // ---------- Editar ponche ----------
  function abrirEditar(p) {
    setEditando({
      id: p.id,
      employeeId: p.employee_id,
      employeeName: p.employee_name,
      hora: toDatetimeLocalPR(p.hora),
      tipo: p.tipo || 'in',
      postId: p.post_id != null && p.post_id !== '' ? String(p.post_id) : '',
      postIdInicial: p.post_id != null && p.post_id !== '' ? String(p.post_id) : '',
      postNameActual: p.post_name || '',
    });
  }

  async function guardarEdicion() {
    if (!editando) return;
    if (!editando.hora || !editando.tipo) {
      setError('Completa la hora y el tipo del ponche');
      return;
    }
    try {
      setGuardandoEdicion(true);
      const horaIso = fromDatetimeLocalPR(editando.hora);
      const body = { id: editando.id, hora: horaIso, tipo: editando.tipo };
      if (editando.postId !== editando.postIdInicial) {
        const post = editando.postId ? postsPorId[editando.postId] : null;
        body.postId = editando.postId ? postIdOriginal(editando.postId) : '';
        body.postName = post ? post.name : null;
        if (editando.postId) {
          const sched = buscarTurno(editando.employeeId, fechaPR12(horaIso), editando.postId);
          if (sched && String(sched.postId) === String(editando.postId)) body.turno = sched.hours;
        }
      }
      const resp = await fetch('/api/attendance', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!resp.ok) throw new Error('No se pudo guardar');
      setEditando(null);
      await cargarPonches();
    } catch (err) {
      setError('Error al guardar el cambio: ' + err.message);
    } finally {
      setGuardandoEdicion(false);
    }
  }

  async function eliminarPonche(p) {
    if (!window.confirm('Seguro que deseas eliminar este ponche? Esta accion no se puede deshacer.')) return;
    try {
      const resp = await fetch('/api/attendance?id=' + p.id, { method: 'DELETE' });
      if (!resp.ok) throw new Error('No se pudo eliminar');
      await cargarPonches();
    } catch (err) {
      setError('Error al eliminar: ' + err.message);
    }
  }

  async function validarPonche(p) {
    try {
      const resp = await fetch('/api/attendance', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.id, aprobar: true }),
      });
      if (!resp.ok) throw new Error('No se pudo validar');
      setPonches((prev) => prev.map((x) => (x.id === p.id ? Object.assign({}, x, { valido: true, alerta: null }) : x)));
      await cargarPonches();
    } catch (err) {
      setError('Error al validar: ' + err.message);
    }
  }

  // ---------- Ponche manual ----------
  function abrirNuevoPonche() {
    setNuevoPonche({
      employeeId: '',
      postId: filtroPuesto !== 'all' && filtroPuesto !== SIN_PUESTO ? filtroPuesto : '',
      postTocado: filtroPuesto !== 'all' && filtroPuesto !== SIN_PUESTO,
      tipo: 'in',
      hora: toDatetimeLocalPR(new Date().toISOString()),
    });
  }

  function cambiarNuevo(cambios) {
    const next = Object.assign({}, nuevoPonche, cambios);
    if (!next.postTocado && (cambios.employeeId !== undefined || cambios.hora !== undefined)) {
      next.postId = sugerirPuesto(next.employeeId, next.hora);
    }
    setNuevoPonche(next);
  }

  async function guardarPoncheManual() {
    if (!nuevoPonche || !nuevoPonche.employeeId || !nuevoPonche.tipo || !nuevoPonche.hora) {
      setError('Completa empleado, tipo y hora');
      return;
    }
    if (!nuevoPonche.postId) {
      const ok = window.confirm('No seleccionaste un puesto. Este ponche no aparecera en las hojas de horario por puesto. Deseas guardarlo de todos modos?');
      if (!ok) return;
    }
    try {
      setGuardandoNuevo(true);
      const emp = employees.find((x) => String(x.id) === String(nuevoPonche.employeeId));
      const horaIso = fromDatetimeLocalPR(nuevoPonche.hora);
      const fechaDDMMYYYY = fechaPR12(horaIso);
      const post = nuevoPonche.postId ? postsPorId[nuevoPonche.postId] : null;
      const sched = buscarTurno(nuevoPonche.employeeId, fechaDDMMYYYY, nuevoPonche.postId);
      const turnoDelPuesto = sched && (!nuevoPonche.postId || String(sched.postId) === String(nuevoPonche.postId)) ? sched.hours : null;
      const resp = await fetch('/api/manual-ponche', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          employeeId: nuevoPonche.employeeId,
          employeeName: emp ? emp.name : null,
          postId: nuevoPonche.postId ? postIdOriginal(nuevoPonche.postId) : null,
          postName: post ? post.name : null,
          turno: turnoDelPuesto,
          tipo: nuevoPonche.tipo,
          hora: horaIso,
        }),
      });
      if (!resp.ok) throw new Error('No se pudo agregar el ponche');
      setNuevoPonche(null);
      await cargarPonches();
      window.alert('Ponche agregado. Queda PENDIENTE: presiona el boton verde de validar en el historial para que aparezca en las hojas PDF.');
    } catch (err) {
      setError('Error al agregar: ' + err.message);
    } finally {
      setGuardandoNuevo(false);
    }
  }

  function horaParaPapel(p) {
    if (p.tipo !== 'in') return horaPR12(p.hora);
    const fecha = fechaPR12(p.hora);
    const sched = buscarTurno(p.employee_id, fecha, p.post_id);
    if (!sched) return horaPR12(p.hora);
    const t = extraerHoraInicio(sched.hours);
    if (!t) return horaPR12(p.hora);
    const inicio = fechaInicioPR(fecha, t.h, t.min);
    if (!inicio) return horaPR12(p.hora);
    const real = new Date(p.hora);
    const diffMin = Math.abs(real.getTime() - inicio.getTime()) / 60000;
    if (diffMin <= 5) return horaPR12(inicio.toISOString());
    return horaPR12(p.hora);
  }

  // ---------- Carga de datos ----------
  // Datos base (puestos, empleados, turnos, pines, dispositivos): se cargan UNA vez al abrir la pagina
  // o al presionar "Actualizar". Los turnos se piden solo del rango que usa esta pagina (ultimos 31 dias).
  async function cargarBase() {
    try {
      const hoyD = new Date();
      const desde = new Date(hoyD); desde.setDate(hoyD.getDate() - 31);
      const hasta = new Date(hoyD); hasta.setDate(hoyD.getDate() + 1);
      const results = await Promise.all([
        getPosts(),
        getSchedulesRange(desde, hasta),
        getEmployees(),
      ]);
      setPosts(results[0] || []);
      setSchedules(results[1] || []);
      setEmployees(results[2] || []);
      try {
        const pinRes = await fetch('/api/has-pin');
        const pinData = await pinRes.json();
        setPinIds(Array.isArray(pinData.employeeIds) ? pinData.employeeIds : []);
      } catch (err) { console.error('Error cargando pines:', err); }
      try {
        const devRes = await fetch('/api/devices');
        const devData = await devRes.json();
        setDevices(Array.isArray(devData.devices) ? devData.devices : []);
      } catch (err) { console.error('Error cargando dispositivos:', err); }
    } catch (err) {
      setError('No se pudo cargar la informacion de asistencia.');
    }
  }

  // Ponches de los ultimos 30 dias (liviano: ya NO trae enlaces de fotos).
  async function cargarPonches() {
    try {
      const r = await fetch('/api/attendance?days=30');
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const d = await r.json();
      setPonches((d && d.ponches) || []);
    } catch (err) {
      setError('No se pudieron cargar los ponches.');
    }
  }

  async function cargar() {
    setError('');
    setActualizando(true);
    try {
      await Promise.all([cargarBase(), cargarPonches()]);
    } finally {
      setLoading(false);
      setActualizando(false);
    }
  }

  // ---------- Fotos bajo demanda (con cache en memoria) ----------
  async function verFotos(p) {
    const enCache = fotosCacheRef.current[p.id];
    if (enCache && enCache.expira > Date.now()) {
      setFotoModal(enCache);
      return;
    }
    try {
      setCargandoFotos(p.id);
      const r = await fetch('/api/attendance?fotos=' + encodeURIComponent(p.id));
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const d = await r.json();
      const item = {
        frontal: d.frontal || null,
        trasera: d.trasera || null,
        nombre: (p.employee_name || '') + ' - ' + tipoLabel(p.tipo) + ' ' + fechaPR12(p.hora) + ' ' + horaPR12(p.hora),
        // se renueva 5 minutos antes de que caduque el enlace
        expira: Date.now() + ((d.expiraEn || 3600) - 300) * 1000,
      };
      fotosCacheRef.current[p.id] = item;
      setFotoModal(item);
    } catch (err) {
      setError('No se pudieron cargar las fotos: ' + err.message);
    } finally {
      setCargandoFotos(null);
    }
  }

  async function verificarLimpieza() {
    try {
      const r = await fetch('/api/cleanup-ponches');
      const d = await r.json();
      setLimpieza(d);
    } catch (err) {
      console.error('Error verificando limpieza:', err);
    }
  }

  async function ejecutarLimpieza() {
    if (!limpieza || !limpieza.count) return;
    const ok = window.confirm('Se eliminaran permanentemente ' + limpieza.count + ' registros de asistencia con mas de ' + limpieza.diasRetencion + ' dias. Esta accion no se puede deshacer. Continuar?');
    if (!ok) return;
    setLimpiando(true);
    try {
      const r = await fetch('/api/cleanup-ponches', { method: 'DELETE' });
      const d = await r.json();
      alert('Se eliminaron ' + (d.deleted || 0) + ' registros antiguos.');
      setLimpieza(null);
      cargarPonches();
    } catch (err) {
      alert('Error al limpiar datos antiguos.');
    } finally {
      setLimpiando(false);
    }
  }

  useEffect(() => {
    cargar();
    // Ya no se recarga todo cada 30 segundos: solo los ponches, cada 2 minutos y solo si la pestana esta visible.
    const id = setInterval(function () {
      if (document.visibilityState === 'visible') cargarPonches();
    }, 120000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (window.L) {
      setLeafletReady(true);
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = () => setLeafletReady(true);
    document.body.appendChild(script);
  }, []);

  const hoy = hoyPR();

  const schedulesHoy = useMemo(function () {
    return schedules.filter((s) => s.date === hoy && !s.isVacancy);
  }, [schedules, hoy]);

  const empleadosPorId = useMemo(function () {
    const map = {};
    employees.forEach((emp) => { map[emp.id] = emp; });
    return map;
  }, [employees]);

  const ponchesPorEmpleado = useMemo(function () {
    const map = {};
    ponches.forEach((p) => {
      const id = p.employee_id;
      if (!map[id]) map[id] = [];
      map[id].push(p);
    });
    Object.keys(map).forEach((k) => map[k].sort((a, b) => new Date(a.hora) - new Date(b.hora)));
    return map;
  }, [ponches]);

  const trabajandoAhora = useMemo(function () {
    const out = [];
    Object.keys(ponchesPorEmpleado).forEach((id) => {
      const arr = ponchesPorEmpleado[id];
      const ultimo = arr[arr.length - 1];
      if (ultimo && ultimo.tipo !== 'out') out.push(ultimo);
    });
    return out;
  }, [ponchesPorEmpleado]);

  const activePonchIds = useMemo(function () {
    return new Set(trabajandoAhora.map((p) => p.id));
  }, [trabajandoAhora]);

  const postIdsConDispositivo = useMemo(function () {
    return new Set(devices
      .filter((d) => d.habilitado)
      .flatMap((d) => (Array.isArray(d.puesto_ids) && d.puesto_ids.length ? d.puesto_ids : (d.puesto_id != null ? [d.puesto_id] : [])))
      .map((id) => String(id)));
  }, [devices]);

  const noHanLlegado = useMemo(function () {
    const ahora = new Date();
    return schedulesHoy.filter((s) => {
      if (!postIdsConDispositivo.has(String(s.postId))) return false;
      const emp = empleadosPorId[s.employeeId];
      if (emp && emp.clock_in_enabled === false) return false;
      const arr = ponchesPorEmpleado[s.employeeId];
      if (arr && arr.some((p) => p.tipo === 'in')) return false;
      const t = extraerHoraInicio(s.hours);
      if (!t) return true;
      const inicio = hoyInicioPR(t.h, t.min);
      return ahora.getTime() >= inicio.getTime() + 5 * 60000;
    });
  }, [schedulesHoy, ponchesPorEmpleado, postIdsConDispositivo, empleadosPorId]);

  const tardanzas = useMemo(function () {
    const out = [];
    schedulesHoy.forEach((s) => {
      const t = extraerHoraInicio(s.hours);
      if (!t) return;
      const arr = ponchesPorEmpleado[s.employeeId];
      const entrada = arr && arr.find((p) => p.tipo === 'in');
      if (!entrada) return;
      const horaPonche = new Date(entrada.hora);
      const programada = hoyInicioPR(t.h, t.min);
      const diffMin = Math.round((horaPonche - programada) / 60000);
      if (diffMin > 5) out.push({ schedule: s, ponche: entrada, minutosTarde: diffMin });
    });
    return out;
  }, [schedulesHoy, ponchesPorEmpleado]);

  const alertas = useMemo(function () {
    return ponches.filter((p) => p.alerta || p.valido === false);
  }, [ponches]);

  // ---------- Historial agrupado por puesto ----------
  const gruposPorPuesto = useMemo(function () {
    const map = {};
    ponches.forEach((p) => {
      const tienePuesto = p.post_id != null && p.post_id !== '';
      const key = tienePuesto ? String(p.post_id) : SIN_PUESTO;
      if (!map[key]) {
        const post = tienePuesto ? postsPorId[key] : null;
        map[key] = {
          key: key,
          nombre: tienePuesto ? ((post && post.name) || p.post_name || ('Puesto ' + key)) : 'Sin puesto asignado',
          ponches: [],
          empleados: new Set(),
        };
      }
      map[key].ponches.push(p);
      map[key].empleados.add(String(p.employee_id));
    });
    return Object.keys(map).map((k) => map[k]).sort(function (a, b) {
      if (a.key === SIN_PUESTO) return 1;
      if (b.key === SIN_PUESTO) return -1;
      return a.nombre.localeCompare(b.nombre, 'es');
    });
  }, [ponches, postsPorId]);

  const gruposVisibles = useMemo(function () {
    if (filtroPuesto === 'all') return gruposPorPuesto;
    return gruposPorPuesto.filter((g) => g.key === filtroPuesto);
  }, [gruposPorPuesto, filtroPuesto]);

  function toggleGrupo(key) {
    setColapsados(Object.assign({}, colapsados, { [key]: !colapsados[key] }));
  }

  function colapsarTodos(valor) {
    const next = {};
    gruposPorPuesto.forEach((g) => { next[g.key] = valor; });
    setColapsados(next);
  }

  // ---------- Mapa ----------
  useEffect(() => {
    if (!leafletReady || !mapRef.current) return;
    const L = window.L;
    if (!mapObjRef.current) {
      mapObjRef.current = L.map(mapRef.current).setView([18.2208, -66.5901], 10);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'OpenStreetMap',
      }).addTo(mapObjRef.current);
    }
    const map = mapObjRef.current;
    map.eachLayer((layer) => {
      if (layer instanceof L.Marker || layer instanceof L.Circle || layer instanceof L.CircleMarker) {
        map.removeLayer(layer);
      }
    });
    posts.forEach((post) => {
      if (post.lat == null || post.lng == null) return;
      const asignadosHoy = schedulesHoy.filter((s) => String(s.postId) === String(post.id));
      const lineasAsignados = asignadosHoy.map((s) => {
        const arr = ponchesPorEmpleado[s.employeeId] || [];
        const ultimo = arr.length ? arr[arr.length - 1] : null;
        if (ultimo && ultimo.tipo === 'out') return null;
        const base = (s.employee_name || 'Guardia') + ' - ' + formatShift12h(s.shift);
        let estado = '';
        if (ultimo) {
          const horaTxt = new Date(ultimo.hora).toLocaleString('en-US', { timeZone: 'America/Puerto_Rico', hour12: true, hour: 'numeric', minute: '2-digit' });
          if (ultimo.tipo === 'in') estado = ' | Entro al turno: ' + horaTxt;
          else if (ultimo.tipo === 'meal_out') estado = ' | En alimento desde: ' + horaTxt;
          else if (ultimo.tipo === 'meal_in') estado = ' | Regreso de alimento: ' + horaTxt;
        }
        return '<br/>' + base + estado;
      }).filter((l) => l !== null);
      const tooltipPuesto = '<strong>' + (post.name || 'Puesto') + '</strong>' + (lineasAsignados.length ? lineasAsignados.join('') : '<br/>Sin turno activo');
      L.marker([post.lat, post.lng]).addTo(map).bindPopup('Puesto: ' + (post.name || '')).bindTooltip(tooltipPuesto, { direction: 'top', sticky: true });
      L.circle([post.lat, post.lng], {
        radius: post.radioMetros || post.radio_metros || 100,
        color: '#2563eb',
        fillOpacity: 0.08,
      }).addTo(map);
    });
    ponches.forEach((p) => {
      if (p.lat == null || p.lng == null) return;
      const activo = p.tipo === 'in' && activePonchIds.has(p.id);
      const color = p.dentro_geofence === false ? '#dc2626' : (activo ? '#2563eb' : '#16a34a');
      const marker = L.circleMarker([p.lat, p.lng], { radius: activo ? 10 : 7, color: color, fillColor: color, fillOpacity: 0.9 }).addTo(map);
      const popupHtml = (activo ? '<div style="color:#2563eb;font-weight:700;margin-bottom:4px;">ACTIVO AHORA</div>' : '')
        + '<strong>' + (p.employee_name || '') + '</strong><br/>'
        + tipoLabel(p.tipo) + ' - ' + new Date(p.hora).toLocaleString('en-US', { timeZone: 'America/Puerto_Rico', hour12: true })
        + (p.post_name ? '<br/>Puesto: ' + p.post_name : '');
      marker.bindPopup(popupHtml);
      if (activo) marker.openPopup();
    });
  }, [leafletReady, posts, ponches, activePonchIds, schedulesHoy, ponchesPorEmpleado]);

  // ---------- Render helpers ----------
  const headers = ['Empleado', 'Turno', 'Tipo', 'Fecha', 'Hora', 'Distancia', 'Dispositivo', 'Fotos', 'Estado', 'Acciones'];

  const filaPonche = function (p) {
    const tieneFotos = !!(p.foto_frontal_url || p.foto_trasera_url);
    const fotos = tieneFotos
      ? e('button', {
          onClick: function () { verFotos(p); },
          disabled: cargandoFotos === p.id,
          style: Object.assign({}, btnSmall, { background: '#1f2937', border: '1px solid rgba(245,197,24,0.35)', color: '#F5C518' }),
        }, cargandoFotos === p.id ? 'Cargando...' : 'Ver fotos')
      : '-';
    const esManual = p.device_uid === 'admin-manual';
    const necesitaValidar = p.valido === false || !!p.alerta;
    const estado = !necesitaValidar
      ? e('span', { style: { color: '#16a34a', fontWeight: 600 } }, 'Valido')
      : (esManual
        ? e('span', { style: { color: '#f59e0b', fontWeight: 600 } }, 'Pendiente')
        : e('span', { style: { color: '#dc2626', fontWeight: 600 } }, 'Invalido'));
    const distancia = p.distancia_metros != null ? Math.round(p.distancia_metros) + 'm' : '-';
    return e('tr', { key: p.id, style: { borderBottom: '1px solid rgba(255,255,255,0.08)' } },
      e('td', { style: tdStyle }, p.employee_name),
      e('td', { style: tdStyle }, formatShift12h(p.turno)),
      e('td', { style: tdStyle }, e('span', { style: { color: tipoColor(p.tipo), fontWeight: 600 } }, tipoLabel(p.tipo))),
      e('td', { style: tdStyle }, fechaPR12(p.hora)),
      e('td', { style: tdStyle },
        e('span', { className: 'gg-pantalla' }, horaPR12(p.hora)),
        e('span', { className: 'gg-papel' }, horaParaPapel(p))
      ),
      e('td', { style: tdStyle }, distancia),
      e('td', { style: tdStyle }, p.device_uid ? p.device_uid.slice(0, 8) : '-'),
      e('td', { style: tdStyle }, fotos),
      e('td', { style: tdStyle }, estado),
      e('td', { style: Object.assign({}, tdStyle, { whiteSpace: 'nowrap' }) },
        necesitaValidar ? e('button', { onClick: function () { validarPonche(p); }, title: 'Validar ponche (aparecera en las hojas PDF)', style: { background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 8px', marginRight: 4, cursor: 'pointer', fontSize: 12, fontWeight: 700 } }, '✓ Validar') : null,
        e('button', { onClick: function () { abrirEditar(p); }, style: { background: '#2563eb', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 8px', marginRight: 4, cursor: 'pointer', fontSize: 12 } }, 'Editar'),
        e('button', { onClick: function () { eliminarPonche(p); }, style: { background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 8px', cursor: 'pointer', fontSize: 12 } }, 'Eliminar')
      )
    );
  };

  const filaHeaders = headers.map(function (h) {
    return e('th', { key: h, style: thStyle }, h);
  });

  const seccionesPuesto = gruposVisibles.map(function (g) {
    const cerrado = !!colapsados[g.key];
    const conteoTipos = { in: 0, out: 0, meal: 0 };
    const pendientes = g.ponches.filter((p) => p.valido === false || !!p.alerta).length;
    g.ponches.forEach((p) => {
      if (p.tipo === 'in') conteoTipos.in += 1;
      else if (p.tipo === 'out') conteoTipos.out += 1;
      else conteoTipos.meal += 1;
    });
    return e('div', { key: g.key, style: { border: '1px solid rgba(245,197,24,0.25)', borderRadius: 10, marginBottom: 14, overflow: 'hidden', background: '#111823' } },
      e('div', {
        onClick: function () { toggleGrupo(g.key); },
        style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', padding: '12px 16px', cursor: 'pointer', background: g.key === SIN_PUESTO ? 'rgba(220,38,38,0.15)' : 'rgba(245,197,24,0.08)' },
      },
        e('div', { style: { display: 'flex', alignItems: 'center', gap: 10 } },
          e('span', { style: { color: '#F5C518', fontSize: 14, width: 14, display: 'inline-block' } }, cerrado ? '▶' : '▼'),
          e('span', { style: { fontWeight: 700, fontSize: 16, color: g.key === SIN_PUESTO ? '#f87171' : '#F5C518' } }, g.nombre)
        ),
        e('div', { style: { display: 'flex', gap: 12, fontSize: 12, color: '#bbb', flexWrap: 'wrap' } },
          e('span', null, g.ponches.length + ' ponches'),
          e('span', null, g.empleados.size + (g.empleados.size === 1 ? ' empleado' : ' empleados')),
          e('span', { style: { color: '#34d399' } }, conteoTipos.in + ' entradas'),
          e('span', { style: { color: '#f87171' } }, conteoTipos.out + ' salidas'),
          e('span', { style: { color: '#fbbf24' } }, conteoTipos.meal + ' alimento'),
          pendientes > 0 ? e('span', { style: { color: '#fff', background: '#b45309', borderRadius: 10, padding: '1px 8px', fontWeight: 700 } }, pendientes + ' por validar') : null
        )
      ),
      cerrado ? null : e('div', { className: 'gg-scroll', style: { overflowX: 'auto', maxHeight: 460, overflowY: 'auto' } },
        e('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: 14 } },
          e('thead', null, e('tr', { style: { textAlign: 'left', borderBottom: '2px solid rgba(255,255,255,0.08)' } }, filaHeaders)),
          e('tbody', null, g.ponches.map(filaPonche))
        )
      )
    );
  });

  const filasAlertas = alertas.map(function (p) {
    const extra = p.dentro_geofence === false
      ? e('span', { key: 'x' }, ' Fuera del area permitida (distancia: ' + Math.round(p.distancia_metros || 0) + 'm).')
      : null;
    return e('div', { key: p.id, style: { border: '1px solid rgba(220,38,38,0.4)', borderRadius: 8, padding: 12, background: 'rgba(220,38,38,0.12)', color: '#fff' } },
      e('strong', null, p.employee_name),
      ' intento marcar ' + tipoLabel(p.tipo).toLowerCase() + ' en ' + (p.post_name || 'puesto sin asignar') + ' a las ' + horaPR12(p.hora) + '.',
      extra
    );
  });

  const itemsNoHanLlegado = noHanLlegado.map(function (s) {
    return e('li', { key: s.id }, (s.employee_name || 'Empleado') + ' - ' + (s.post_name || 'Puesto') + ' (' + formatShift12h(s.shift) + ')');
  });

  const itemsTardanzas = tardanzas.map(function (t, i) {
    return e('li', { key: i }, (t.schedule.employee_name || 'Empleado') + ' - ' + t.minutosTarde + ' min tarde');
  });

  const opcionesPuesto = function (textoVacio) {
    return [e('option', { key: 'blank', value: '' }, textoVacio)].concat(postsOrdenados.map(function (post) {
      return e('option', { key: post.id, value: String(post.id) }, post.name);
    }));
  };

  const opcionesTipo = TIPOS_OPCIONES.map(function (t) {
    return e('option', { key: t.value, value: t.value }, t.label);
  });

  // ---------- Modales ----------
  const modalEditar = editando ? e('div', { onClick: function () { setEditando(null); }, style: modalOverlayStyle },
    e('div', { onClick: function (ev) { ev.stopPropagation(); }, style: modalBoxStyle },
      e('h3', { style: { marginTop: 0, marginBottom: 4, fontSize: 16 } }, 'Editar ponche'),
      e('div', { style: { fontSize: 13, color: '#aaa', marginBottom: 14 } }, editando.employeeName || ''),
      e('label', { style: modalLabelStyle }, 'Tipo de ponche'),
      e('select', {
        value: editando.tipo,
        onChange: function (ev) { setEditando(Object.assign({}, editando, { tipo: ev.target.value })); },
        style: modalInputStyle,
      }, opcionesTipo),
      e('label', { style: modalLabelStyle }, 'Puesto'),
      e('select', {
        value: editando.postId,
        onChange: function (ev) { setEditando(Object.assign({}, editando, { postId: ev.target.value })); },
        style: modalInputStyle,
      }, opcionesPuesto('Sin puesto asignado')),
      (editando.postIdInicial && !postsPorId[editando.postIdInicial])
        ? e('div', { style: { fontSize: 12, color: '#fbbf24', marginTop: -8, marginBottom: 12 } }, 'Puesto original: ' + (editando.postNameActual || editando.postIdInicial) + ' (ya no existe en la lista)')
        : null,
      e('label', { style: modalLabelStyle }, 'Fecha y hora'),
      e('input', {
        type: 'datetime-local',
        value: editando.hora,
        onChange: function (ev) { setEditando(Object.assign({}, editando, { hora: ev.target.value })); },
        style: modalInputStyle,
      }),
      e('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 } },
        e('button', { onClick: function () { setEditando(null); }, style: btnGris }, 'Cancelar'),
        e('button', { onClick: guardarEdicion, disabled: guardandoEdicion, style: Object.assign({}, btnGris, { background: '#2563eb' }) }, guardandoEdicion ? 'Guardando...' : 'Guardar')
      )
    )
  ) : null;

  const modalNuevo = nuevoPonche ? e('div', { onClick: function () { setNuevoPonche(null); }, style: modalOverlayStyle },
    e('div', { onClick: function (ev) { ev.stopPropagation(); }, style: modalBoxStyle },
      e('h3', { style: { marginTop: 0, marginBottom: 14, fontSize: 16 } }, 'Agregar ponche manual'),
      e('label', { style: modalLabelStyle }, 'Empleado'),
      e('select', {
        value: nuevoPonche.employeeId,
        onChange: function (ev) { cambiarNuevo({ employeeId: ev.target.value }); },
        style: modalInputStyle,
      }, [e('option', { key: 'blank', value: '' }, 'Selecciona empleado')].concat(employees.map(function (emp) {
        return e('option', { key: emp.id, value: emp.id }, emp.name);
      }))),
      e('label', { style: modalLabelStyle }, 'Puesto'),
      e('select', {
        value: nuevoPonche.postId,
        onChange: function (ev) { setNuevoPonche(Object.assign({}, nuevoPonche, { postId: ev.target.value, postTocado: true })); },
        style: modalInputStyle,
      }, opcionesPuesto('Selecciona puesto')),
      (!nuevoPonche.postTocado && nuevoPonche.postId)
        ? e('div', { style: { fontSize: 12, color: '#34d399', marginTop: -8, marginBottom: 12 } }, 'Puesto sugerido segun el horario del empleado')
        : null,
      e('label', { style: modalLabelStyle }, 'Tipo de ponche'),
      e('select', {
        value: nuevoPonche.tipo,
        onChange: function (ev) { setNuevoPonche(Object.assign({}, nuevoPonche, { tipo: ev.target.value })); },
        style: modalInputStyle,
      }, opcionesTipo),
      e('label', { style: modalLabelStyle }, 'Fecha y hora'),
      e('input', {
        type: 'datetime-local',
        value: nuevoPonche.hora,
        onChange: function (ev) { cambiarNuevo({ hora: ev.target.value }); },
        style: modalInputStyle,
      }),
      e('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 } },
        e('button', { onClick: function () { setNuevoPonche(null); }, style: btnGris }, 'Cancelar'),
        e('button', { onClick: guardarPoncheManual, disabled: guardandoNuevo, style: Object.assign({}, btnGris, { background: '#16a34a' }) }, guardandoNuevo ? 'Guardando...' : 'Guardar')
      )
    )
  ) : null;

  // ---------- Render ----------
  return e('div', { style: { padding: 24, background: '#0d0d0d', color: '#fff', minHeight: '100vh' } },
    e('h1', { style: { fontSize: 24, fontWeight: 700, marginBottom: 16 } }, 'Dashboard Asistencia'),
    e('style', {}, '.gg-papel { display: none; } @media print { .gg-pantalla { display: none !important; } .gg-papel { display: inline !important; } .gg-scroll { max-height: none !important; overflow: visible !important; } }'),
    (can('canDownloadWorkPlans') ? e('div', { style: { marginBottom: 16 } },
      e('button', { onClick: limpieza ? ejecutarLimpieza : verificarLimpieza, disabled: limpiando, style: { background: limpieza ? '#ef4444' : '#333', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 13 } },
        limpiando ? 'Limpiando...' : (limpieza ? ('Confirmar eliminar ' + limpieza.count + ' registros (+' + limpieza.diasRetencion + ' dias)') : 'Verificar datos antiguos (+30 dias)')),
      e('button', { onClick: abrirNuevoPonche, style: { background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 13, marginLeft: 8 } }, 'Agregar ponche manual'),
      (limpieza && !limpiando) ? e('span', { style: { marginLeft: 10, fontSize: 12, color: '#999' } }, 'Datos anteriores a ' + new Date(limpieza.limite).toLocaleDateString('es-PR')) : null
    ) : null),
    error ? e('div', { style: { color: '#dc2626', marginBottom: 12 } }, error) : null,
    e('div', { style: { display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' } },
      e('div', { style: cardStyle('#1e3a8a') },
        e('div', { style: cardLabel }, 'Trabajando ahora'),
        e('div', { style: cardNum }, trabajandoAhora.length)
      ),
      e('div', { style: cardStyle('#c2410c') },
        e('div', { style: cardLabel }, 'No han llegado'),
        e('div', { style: cardNum }, noHanLlegado.length)
      ),
      e('div', { style: cardStyle('#b45309') },
        e('div', { style: cardLabel }, 'Tardanzas hoy'),
        e('div', { style: cardNum }, tardanzas.length)
      ),
      e('div', { style: cardStyle('#b91c1c') },
        e('div', { style: cardLabel }, 'Alertas'),
        e('div', { style: cardNum }, alertas.length)
      )
    ),
    alertas.length > 0 ? e('div', { style: { marginBottom: 24 } },
      e('h2', { style: h2Style('#dc2626') }, 'Alertas'),
      e('div', { style: { display: 'flex', flexDirection: 'column', gap: 8 } }, filasAlertas)
    ) : null,
    e('div', { style: { display: 'flex', gap: 24, marginBottom: 24, flexWrap: 'wrap' } },
      e('div', { style: { flex: 1, minWidth: 280 } },
        e('h2', { style: h2Style() }, 'No han llegado'),
        noHanLlegado.length === 0
          ? e('div', { style: { color: '#34d399' } }, 'Todos los empleados con turno hoy ya marcaron entrada.')
          : e('ul', { style: { paddingLeft: 18 } }, itemsNoHanLlegado)
      ),
      e('div', { style: { flex: 1, minWidth: 280 } },
        e('h2', { style: h2Style() }, 'Tardanzas hoy'),
        tardanzas.length === 0
          ? e('div', { style: { color: '#34d399' } }, 'No hay tardanzas registradas hoy.')
          : e('ul', { style: { paddingLeft: 18 } }, itemsTardanzas)
      )
    ),
    e('h2', { style: h2Style() }, 'Mapa de puestos y ponches'),
    e('div', { ref: mapRef, style: { height: 360, borderRadius: 12, marginBottom: 24, background: '#1a2332' } }),
    e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 12 } },
      e('h2', { style: Object.assign({}, h2Style(), { marginBottom: 0 }) }, 'Historial de ponches por puesto (ultimos 30 dias)'),
      e('div', { style: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' } },
        e('select', {
          value: filtroPuesto,
          onChange: function (ev) { setFiltroPuesto(ev.target.value); },
          style: { padding: '6px 10px', borderRadius: 6, border: '1px solid #555', background: '#0d0d0d', color: '#fff', fontSize: 13 },
        }, [e('option', { key: 'all', value: 'all' }, 'Todos los puestos (' + gruposPorPuesto.length + ')')].concat(gruposPorPuesto.map(function (g) {
          return e('option', { key: g.key, value: g.key }, g.nombre + ' (' + g.ponches.length + ')');
        }))),
        e('button', { onClick: cargar, disabled: actualizando, style: Object.assign({}, btnSmall, { background: '#1e3a8a' }) }, actualizando ? 'Actualizando...' : 'Actualizar'),
        e('button', { onClick: function () { colapsarTodos(false); }, style: btnSmall }, 'Expandir todo'),
        e('button', { onClick: function () { colapsarTodos(true); }, style: btnSmall }, 'Colapsar todo')
      )
    ),
    (ponches.length === 0 && !loading)
      ? e('div', { style: { padding: 16, textAlign: 'center', color: '#64748b', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10 } }, 'Aun no hay ponches registrados en los ultimos 30 dias.')
      : seccionesPuesto,
    fotoModal ? e('div', {
      onClick: function () { setFotoModal(null); },
      style: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: 16, zIndex: 9999 },
    },
      fotoModal.nombre ? e('div', { style: { color: '#F5C518', fontWeight: 700, textAlign: 'center' } }, fotoModal.nombre) : null,
      e('div', { style: { display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto' } },
        fotoModal.frontal ? e('img', { src: fotoModal.frontal, alt: 'frontal', style: { maxWidth: 'min(90vw, 480px)', maxHeight: '80vh', borderRadius: 12 } }) : null,
        fotoModal.trasera ? e('img', { src: fotoModal.trasera, alt: 'trasera', style: { maxWidth: 'min(90vw, 480px)', maxHeight: '80vh', borderRadius: 12 } }) : null,
        (!fotoModal.frontal && !fotoModal.trasera) ? e('div', { style: { color: '#ccc' } }, 'Este ponche no tiene fotos disponibles.') : null
      ),
      e('div', { style: { color: '#888', fontSize: 12 } }, 'Toca en cualquier parte para cerrar')
    ) : null,
    modalEditar,
    modalNuevo
  );
}
